import { ThemeSegmentRail, type ThemeSegmentRailProps } from './ThemeSegmentRail'

type Props = Pick<
  ThemeSegmentRailProps,
  'compact' | 'nowrap'
> & {
  /** 个人页：显示「外观主题」标题 */
  showTitle?: boolean
}

/**
 * 外观主题分段选择器（顶栏 compact / 设置页网格）。
 * 移动端顶栏请用 {@link ThemeHeaderPicker}，避免 8 枚按钮挤占横向空间。
 */
export function ThemeSegment({ compact, nowrap, showTitle }: Props) {
  const group = <ThemeSegmentRail compact={compact} nowrap={nowrap} />

  if (compact) {
    return group
  }

  if (showTitle) {
    return (
      <div className="space-y-2">
        <span className="text-sm font-medium text-ink">外观主题</span>
        {group}
      </div>
    )
  }

  return group
}
